export default {
	title: "Ritual Closing",
	closeRitual: "Close Ritual",
	closingDate: "Closing date",
	closingTime: "Closing time",
	closingConfirm: "Confirm closing this ritual? This action cannot be undone.",
	noTickets: "No tickets registered for this ritual",
	sections: {
		messages: "Messages",
		return: "Return",
	},
	addMessage: "Add message",
	noMessages: "No messages added",
	returnType: {
		NEXT_RITUAL: "Next Ritual",
		SPECIFIC_RITUAL: "Specific Ritual",
		SPECIFIC_CARD: "Specific Card",
	},
	returnFields: {
		returnType: "Return Type",
		selectRitual: "Select the ritual",
		selectAttendanceType: "Card type",
		quantity: "Quantity",
		indefinite: "Indefinite",
		notes: "Notes",
	},
	quickClose: {
		confirm: "Confirm closing this ritual? This action cannot be undone.",
	},
	messages: {
		closed: "Ritual closed successfully",
		closeError: "Error closing ritual",
		alreadyClosed: "This ritual is already closed",
	},
	summary: {
		messagesLabel: "messages",
		returnsLabel: "returns",
	},
	pendingReturns: "Pending returns",
	expandAll: "Expand all",
	collapseAll: "Collapse all",
};
